import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getTestimonials } from './services/firebaseService';
import testimonialsHero from './assets/testimonials.png';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

const Testimonial = () => {
  const { t } = useTranslation();
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTestimonials();
  }, []);

  const loadTestimonials = async () => {
    setLoading(true);
    const result = await getTestimonials();
    if (result.success) {
      setTestimonials(result.testimonials);
    }
    setLoading(false);
  };
  
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <section className="relative flex min-h-[280px] h-[42vh] md:h-[500px] w-full items-center justify-center overflow-hidden bg-gray-900">
        <div className="absolute inset-0 z-0">
          <img
            src={testimonialsHero}
            alt={t('testimonials.heroImageAlt')}
            className="h-full w-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary/90 to-transparent" />
        </div>
        <div className="relative z-10 mx-auto max-w-[800px] px-4 text-center md:px-8">
          <h1 className="mb-4 text-4xl font-bold text-white md:text-5xl">{t('testimonials.heroTitle')}</h1>
          <p className="text-lg text-gray-100 md:text-xl">
            {t('testimonials.heroSubtitle')}
          </p>
        </div>
      </section>

      <main className="flex-1 max-w-5xl mx-auto px-2 md:px-8 py-10 flex flex-col items-center">
        {loading ? (
          <div className="w-full text-center py-8">
            <div className="text-gray-500">{t('testimonials.loading')}</div>
          </div>
        ) : testimonials.length === 0 ? (
          <div className="w-full text-center py-8">
            <div className="text-gray-500">{t('testimonials.empty')}</div>
          </div>
        ) : (
          <div className="w-full space-y-6">
            {testimonials.map((item) => (
              <div
                key={item.id}
                className="relative w-full rounded-r-lg border-l-[6px] border-blue-400 bg-gray-100 p-6 md:p-8 shadow-sm flex flex-col md:flex-row items-center gap-6 overflow-hidden"
              >
                <div className="absolute top-0 right-0 p-4 opacity-10 pointer-events-none">
                  <FormatQuoteIcon className="!w-16 !h-16 text-gray-700" />
                </div>
                <div className="hidden md:flex h-24 w-24 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white">
                  {item.image ? (
                    <img
                      src={item.image}
                      alt={t('testimonials.imageAlt')}
                      className="h-full w-full object-cover"
                    />
                  ) : (
                    <span className="text-4xl text-gray-500">🤝</span>
                  )}
                </div>
                <div>
                  <p className="max-w-[800px] text-lg text-gray-700">&quot;{item.text}&quot;</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default Testimonial;
